import { httpRequest } from "../../http";

import { Employee } from "@models/employee.model";
import { Person } from "@models/person.model";
import { EmployeeSerializer } from "@models/serializers/employeeSerializer";

export class CommandCreatePerson {
  async run(person: Person, file?: File) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/employees/`;
    const payload = { ...person, profile_picture: file };
    const body = {
      person_data: payload,
    };
    try {
      const response = await httpRequest<any>(url, { method: "POST", body });
      return this.deserialize(response);
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }

  deserialize(data: any): Employee {
    const serializer = new EmployeeSerializer();
    return serializer.deserialize(data);
  }
}
